import {
    ChatBubbleBottomCenterTextIcon,
    ChatBubbleOvalLeftEllipsisIcon,
    EnvelopeIcon,
    PhoneArrowUpRightIcon,
  } from "@heroicons/react/24/outline";
  import { FaInstagram } from "react-icons/fa6";
  import { RiMessengerLine, RiWhatsappLine } from "react-icons/ri";
  
  export const Icons = {
    whatsapp: <RiWhatsappLine className="size-8 mt-1" />,
    chat: <ChatBubbleOvalLeftEllipsisIcon className="size-8" />,
    sms: <ChatBubbleBottomCenterTextIcon className="size-8" />,
    voice: <PhoneArrowUpRightIcon className="size-7 mt-1" />,
    email: <EnvelopeIcon className="size-8" />,
    messenger: <RiMessengerLine className="size-8" />,
    instagram: <FaInstagram className="size-8" />,
  };
  
  function AssistantIcon(props) {
    const { assistantType } = props;
  
    return (
      <div className="h-10 w-10">
        {Icons[assistantType]}
      </div>
    );
  }
  
  export default AssistantIcon;
  